export const resources = {
    "Use Cases": [
        {
            name: "Real World Application",
            href: "https://keelmind.com/documents/use-cases/Use Case - Real World Application PDF.pdf",
        },
        {
            name: "Self Checks",
            href: "https://keelmind.com/documents/use-cases/Use Case - Self Checks PDF.pdf",
        },
        {
            name: "Simplify Your Workflow",
            href: "https://keelmind.com/documents/use-cases/Use Case - Simplify your Workflow PDF.pdf",
        },
    ],
    "Lesson Plans": [
        {
            name: "Demonstrating Understanding of Mental Disorders and Treatment",
            href: "https://keelmind.com/documents/lesson-plans/Demonstrating Understanding of Mental Disorders and Treatment PDF.pdf",
        },
        {
            name: "Innovations in Teletherapy - Advanced Techniques and Ethical Dilemmas",
            href: "https://keelmind.com/documents/lesson-plans/Innovations in Teletherapy - Advanced Techniques and Ethical Dilemmas PDF.pdf",
        },
        {
            name: "Understanding and Creating Progress Notes",
            href: "https://keelmind.com/documents/lesson-plans/Understanding and Creating Progress Notes PDF.pdf",
        },
    ],
};
